.revenue-cell {
	justify-content: start;
}